/**
 * Uma variedade de rotas acessíveis ao público
 * Essas rotas não requerem autenticação
 * @type {string[]}
 */
export const publicRoutes = [
  "/",
  "/auth/new-verification",
  "/auth/set-password",
  "/termos-de-uso",
  "/politica-privacidade",
];

/**
 * Prefixos de rotas públicas (qualquer sub-rota é pública)
 * @type {string[]}
 */
export const publicRoutePrefixes = ["/impressao", "/proposta"];

/**
 * Uma matriz de rotas usadas para autenticação
 * Essas rotas redirecionarão os usuários logados para /dashboard
 * @type {string[]}
 */
export const authRoutes = [
  "/auth/login",
  "/auth/register",
  "/auth/error",
  "/auth/reset",
  "/auth/new-password",
  "/auth/set-password",
];

/**
 * O prefixo para rotas de autenticação de API
 * As rotas que começam com este prefixo são usadas para fins de autenticação de API
 * @type {string}
 */
export const apiAuthPrefix = "/api/auth";

/**
 * O caminho de redirecionamento padrão após o login
 * @type {string}
 */
export const DEFAULT_LOGIN_REDIRECT = "/dashboard";

/**
 * O caminho de redirecionamento padrão após salvar
 * @type {string}
 */
export const DEFAULT_REDIRECT = "/dashboard";

/**
 * O caminho da página inicial
 * @type {string}
 */
export const HOME_PAGE = "/dashboard";

/**
 * O caminho da página inicial de orçamentos
 * @type {string}
 */
export const ORCAMENTOS_HOME_PAGE = "/orcamentos";

/**
 * Mapeamento de permissões por rota
 * @type {Record<string, string[]>}
 */
export const routePermissions: Record<string, string[]> = {
  // Rotas gerais
  "/configuracoes/gerais": ["configGerais"],
  "/configuracoes/plano": ["planosMeuPlano"],
  "/configuracoes/dados_empresa": ["configUpdDadosEmpresa"],
  "/configuracoes/marca_empresa": ["configUpdMarcaEmpresa"],
  "/configuracoes/empresas": ["empresaListar"],
  "/configuracoes/certificado_digital": ["configAddCertificado"],
  "/configuracoes/emails": ["modelosEmailListar"],
  "/configuracoes/emails/editar/": ["modelosEmailEditar"],
  "/configuracoes/emails/visualizar/": ["modelosEmailVisualizar"],
  "/orcamentos/opcoes/emails": ["modelosEmailListar"],
  "/orcamentos/opcoes/emails/editar/": ["modelosEmailEditar"],
  "/orcamentos/opcoes/emails/visualizar/": ["modelosEmailVisualizar"],
  "/ordens_servico/opcoes/emails": ["modelosEmailListar"],
  "/ordens_servico/opcoes/emails/editar/": ["modelosEmailEditar"],
  "/ordens_servico/opcoes/emails/visualizar/": ["modelosEmailVisualizar"],
  "/configuracoes/avisos_email": ["avisosEmailListar"],
  // Rotas de perfil
  "/configuracoes/usuarios/grupos": ["perfilListar"],
  "/configuracoes/usuarios/grupos/adicionar": ["perfilAdicionar"],
  "/configuracoes/usuarios/grupos/permissoes/": ["permissionGerenciaPerfil"],
  "/configuracoes/usuarios/grupos/visualizar/": ["perfilVisualizar"],
  "/configuracoes/usuarios/grupos/editar/": ["perfilEditar"],
  // Rotas de usuário
  "/configuracoes/usuarios": ["userListar"],
  "/configuracoes/usuarios/adicionar": ["userAdicionar"],
  "/configuracoes/usuarios/permissoes/": ["permissionGerenciarUser"],
  "/configuracoes/usuarios/visualizar/": ["userVisualizar"],
  "/configuracoes/usuarios/editar/": ["userEditar"],
  // Rotas de grades de produtos
  "/produtos/opcoes/grades": ["gradeProdutoListar"],
  "/produtos/opcoes/grades/adicionar": ["gradeProdutoAdicionar"],
  "/produtos/opcoes/grades/visualizar/": ["gradeProdutoVisualizar"],
  "/produtos/opcoes/grades/editar/": ["gradeProdutoEditar"],
  // Rotas de Vouchers (Estética)
  "/estetica/vouchers": ["voucherListar"],
  "/estetica/vouchers/adicionar": ["voucherAdicionar"],
  "/estetica/vouchers/visualizar/": ["voucherVisualizar"],
  "/estetica/vouchers/editar/": ["voucherEditar"],
};
